import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import { Add, Delete, UploadImg, closeCircle } from '../../Svg';
import api from '../../utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getSliders, sliderThunk } from '../../redux/appearanceSlice';

const Slider = ({ Accordions, handleChange, expanded, isImage, isVideo }) => {
    const [loadings, setLoading] = useState(null)
   const dispatch = useDispatch()
    const sliderRef = useRef()
    const {loading,sliders} = useSelector((state)=>state.appearances)


    
    useEffect(()=>{
        dispatch(getSliders())
    },[])

    const formik = useFormik({
        initialValues: {
            sliders: sliders?.data[0]?.sliders || [{
                    title: '',
                    description: '',
                    image: '',
                    buttonText: '',
                    buttonLink: '',
                },
            ]  
        },
        validationSchema: Yup.object({
            sliders: Yup.array().of(
                Yup.object().shape({
                    title: Yup.string().required('Title is required'),
                    description: Yup.string().required('Description is required'),
                    image: Yup.string().required('Image is required'),
                   
                })
            ),
        }),
        onSubmit: (values) => {
            console.log('Form Values:', values);
            dispatch(sliderThunk(values))
        },
    });

    const addSlider = () => {
        formik.setFieldValue('sliders', [
            ...formik.values.sliders,
            { title: '', description: '', image: '', buttonText: '', buttonLink: '' },
        ]);
    };

    const removeSlider = (index) => {
        const updatedSliders = formik.values.sliders.filter((_, idx) => idx !== index);
        formik.setFieldValue('sliders', updatedSliders);
    };

    const handleImageChange = async (e, attribute, index) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        const updatedLoading = [...(loadings || [])];
        updatedLoading[index] = true; 
        setLoading(updatedLoading);
        try {
            if (file) {

                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                console.log(data);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })

                    formik.setFieldValue(attribute, data?.data?.url)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            updatedLoading[index] = false; // Reset loading for the current index
        setLoading(updatedLoading);
        }
    };

    const handleRemove = (repo) => {
        formik.setFieldValue(repo, '');
    };

    useEffect(() => {
        if (sliders?.data[0]?.sliders) {
            formik.setValues({ sliders: sliders.data[0].sliders });
        }
    }, [sliders]);

    // console.log(loadings);
    
    
    return (
        <form onSubmit={formik.handleSubmit}>
            <Accordions
                sx={{ marginBottom: "20px" }}
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography
                        sx={{
                            fontSize: "16px",
                            color: "#1D1F2C",
                        }}
                    >
                        Sliders
                    </Typography>
                </AccordionSummary>

                <AccordionDetails
                    sx={{
                        background: '#F0F1F3B2',
                        margin: "0px 20px 20px 20px",
                    }}
                >
                    {formik.values?.sliders?.map((slider, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                            <label className={styles.addCatLabel}>
                                Slider {index + 1}
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <input
                                        type="text"
                                        name={`sliders[${index}].title`}
                                        className={styles.addCatInput}
                                        placeholder="Enter title"
                                        value={slider.title}
                                        onChange={formik.handleChange}
                                    />
                                    {formik.values.sliders.length > 1 ?
                                        <button
                                            style={{ border: 'none', borderRadius: '8px' }}
                                            type="button"
                                            onClick={() => removeSlider(index)}
                                        >
                                            <Delete />
                                        </button>
                                        : null}
                                </div>
                                {formik.errors.sliders?.[index]?.title && (
                                    <div className={styles.errorText}>
                                        {formik.errors.sliders[index].title}
                                    </div>
                                )}
                            </label>

                            <label className={styles.addCatLabel}>
                                Description
                                <input
                                    type="text"
                                    name={`sliders[${index}].description`}
                                    className={styles.addCatInput}
                                    placeholder="Enter description"
                                    value={slider.description}
                                    onChange={formik.handleChange}
                                />
                                {formik.errors.sliders?.[index]?.description && (
                                    <div className={styles.errorText}>
                                        {formik.errors.sliders[index].description}
                                    </div>
                                )}
                            </label>



                            <div className={styles.imageUpload}>
                                <p className={styles.addCatLabel}>Image</p>
                                {loadings?.[index] ? (
                                    <div>Please wait...</div>
                                ) : (
                                    <>
                                        {slider.image ? (
                                            <div className={styles.uploadBox} style={{ display: 'flex', justifyContent: 'center' }}>
                                                {isImage(slider.image) && (
                                                    <img src={slider.image} alt="Preview" className={styles.previewImage} style={{width:'100%',objectFit:'contain'}}/>
                                                )}  
                                                {isVideo(slider.image) && (
                                                    <video controls className={styles.previewImage}>
                                                        <source src={slider.image} type="video/mp4" />
                                                    </video>
                                                )}
                                                <div className={styles.cancel_cross} onClick={() => handleRemove(`sliders[${index}].image`)}>
                                                    {closeCircle()}
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                className={styles.uploadBox}
                                                style={{ background: '#fff', cursor: 'pointer' }}
                                                onClick={() => sliderRef.current.click()}
                                                onDrop={(e) => {
                                                    e.preventDefault();
                                                    handleImageChange(e, `sliders[${index}].image`, 'slider',index);
                                                }}
                                                onDragOver={(e) => e.preventDefault()}
                                            >
                                                <span className={styles.uploadIcon}><UploadImg /></span>
                                                <p className={styles.addCatPara}>Drag and drop image here, or click to upload</p>
                                                <button type="button" className={styles.addImgBtn}>Add Image/Video</button>
                                                <input
                                                    type="file"
                                                    ref={sliderRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageChange(e, `sliders[${index}].image`, 'slider',index)}
                                                    accept="image/*,video/*"
                                                />
                                            </div>
                                        )}
                                    </>
                                )}
                                {formik.errors.sliders?.[index]?.image && (
                                    <div className={styles.errorText}>
                                        {formik.errors.sliders[index].image}
                                    </div>
                                )}
                            </div>


                            <label className={styles.addCatLabel} >
                                Button link
                                <div style={{ display: 'flex', alignItems: "center", gap: '10px' }}>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="Button link"
                                            className={styles.addCatInput}
                                            name={`sliders[${index}].buttonText`}
                                            value={slider.buttonText}
                                            onChange={formik.handleChange}
                                        />

                                    </div>

                                    <div style={{ display: 'flex', alignItems: "center", width: "80%" }}>
                                        <div className={styles.https}>https://</div>
                                        <input
                                            type="text"
                                            placeholder="Add Redirection Link Here "
                                            className={styles.addCatInput}
                                            name={`sliders[${index}].buttonLink`}
                                            value={slider.buttonLink}
                                            onChange={formik.handleChange}
                                            style={{ borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", marginTop: "10px" }}
                                        />
                                    </div>
                                </div>



                            </label>
                        </div>
                    ))}

                    <button
                        type="button"
                        className={styles.addVar}
                        onClick={addSlider}
                        style={{ cursor: 'pointer', border: "1px solid #96969696" }}
                    >
                        <Add /> Add Slider
                    </button>

                    <div className={styless.displayFlex} style={{ margin: "10px 0px 10px 0px" }}>
                        <button className={styless.cancelBtn} onClick={() => formik.resetForm()}>Cancel</button>
                        <button className={styless.submitBtn} type="submit" >{loading ? 'please wait...' : 'Save changes'}</button>

                    </div>
                </AccordionDetails>
            </Accordions>
        </form>
    );
};

export default Slider;
